<template>
  <!-- $route.name === 'homeIndex' ? 'se-bgc-white' : 'se-bgc-333', -->
  <div :class="['se-layout', 'se-full-vw', 'se-scroll-y']">
    <div class="se-header se-flex-h-c se-h-60 se-bgc-white se-bs-b">
      <div class="se-header-content se-w-p-65 se-flex aic jcsb se-h-p-100">
        <div class="se-flex aic" style="flex: 1">
          <img
            src="../assets/images/logo2.png"
            style="height: 40px; margin-right: 50px; cursor: pointer"
            @click="goHome"
          />
          <el-menu
            mode="horizontal"
            menu-trigger="hover"
            @select="menuSelect"
            text-color="#333"
            style="width: 100px"
          >
            <el-submenu index="2">
              <!-- <template slot="title">{{
                lastSort.specialtyName || "课程分类"
              }}</template> -->
              <template slot="title">{{ "课程分类" }}</template>
              <el-tabs
                ref="navTabs"
                tab-position="left"
                style="width: 266px"
                class="title-tab"
                v-model="courseSort"
                @mouseover.native="hoverTab"
                @tab-click="tabClick"
              >
                <el-tab-pane
                  v-for="(item, index) of specialtys"
                  :key="index"
                  :name="item.id"
                >
                  <div slot="label" class="tab-lable">
                    {{ item.specialtyName }}
                    <i
                      class="el-icon-arrow-right"
                      v-if="item.cmsSpecialtyList.length"
                    ></i>
                  </div>
                  <ul v-for="(key, i) of item.cmsSpecialtyList" :key="i">
                    <li
                      :class="childSort === key.id ? 'active' : ''"
                      @click="getLastSort(key, item.id)"
                    >
                      {{ key.specialtyName }}
                    </li>
                  </ul>
                </el-tab-pane>
              </el-tabs>
            </el-submenu>
          </el-menu>
          <!-- <el-cascader
            v-model="value"
            :props="props"
            :options="courseCateList"
          @change="handleChange">
          </el-cascader> -->
          <div class="se-flex aic se-m-l-40" style="flex: 1">
            <input
              v-model="searchTxt"
              placeholder="输入关键词"
              style="flex: 0.8"
            />
            <el-button type="danger" @click="goSearch">搜索</el-button>
          </div>
        </div>
        <div class="se-flex aic ft-14-606">
          <el-badge :value="total" :hidden="!total" class="item cp">
            <i
              class="el-icon-bell"
              style="font-size: 23px; margin-left: 20px"
              @click="goMsg"
            ></i>
          </el-badge>
          <!-- <div
            class="se-m-r-15 cp"
            style="margin-left: 16px"
            @click="goUserInfo('1')"
          >
            待办事宜
          </div> -->
          <!-- <div class="se-line"></div> -->
          <div class="se-p-l-15 se-p-r-15 cp" @click="goUserInfo('2')">
            我的学习
          </div>
          <div class="se-line"></div>
          <div>
            <div class="se-m-l-15 cp" v-if="!token">
              <span @click="toLogin">登录</span>
              /
              <span @click="toRegister">注册</span>
            </div>
            <el-dropdown @command="handleCommand" v-else>
              <div class="se-flex aic" style="cursor: pointer">
                <div class="se-m-r-10 ft-14-606 se-m-l-10">
                  {{ user.persionName || "新学员" }}
                </div>

                <el-avatar
                  :size="32"
                  :src="user.avatar || require('../assets/images/logo2.png')"
                ></el-avatar>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="user.roles && user.roles.length !== 0"
                    class="se-flex aic"
                    command="adminA"
                  >
                    <img
                      src="../assets/icons/admin1.png"
                      style="width: 15px; height: 15px"
                      class="se-m-r-10 img-1"
                    />
                    管理控制台
                  </el-dropdown-item>
                  <el-dropdown-item class="se-flex aic" command="userInfo">
                    <img
                      src="../assets/icons/avaUser1.png"
                      style="width: 15px; height: 15px"
                      class="se-m-r-10 img-2"
                    />
                    个人信息
                  </el-dropdown-item>
                  <el-dropdown-item class="se-flex aic" command="userSet">
                    <img
                      src="../assets/icons/avaSet1.png"
                      style="width: 16px; height: 14px"
                      class="se-m-r-10 img-3"
                    />
                    账户设置
                  </el-dropdown-item>
                  <el-dropdown-item class="se-flex aic" command="logout">
                    <img
                      src="../assets/icons/avaLogout1.png"
                      style="width: 15px; height: 15px"
                      class="se-m-r-10 img-4"
                    />
                    退出登录
                  </el-dropdown-item>
                </el-dropdown-menu>
              </div>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="se-container se-flex-h-c se-flex-ai-fs se-p-t-20 se-p-b-20">
      <!-- $route.name === 'homeIndex' ? 'se-bgc-white' : 'se-bgc-333', -->
      <router-view :class="['se-container-content', 'se-w-p-65']" />
    </div>
    <div class="se-footer se-flex-h-c se-h-150 bgc-333">
      <div class="se-footer-content se-w-p-65 se-h-p-100 se-flex jcc aic">
        <div class="se-footer-body">
          <div class="ft-14-ca">
            地址：湖北省武汉市洪山区黄家湖西路3号
            <div class="se-flex jcc se-m-t-10">
              <div class="se-m-r-20">电话：027-88147166</div>
              <div>电邮：430065</div>
            </div>
          </div>
          <div class="ft-12-ca se-m-t-10 se-m-b-10">
            Copyright © 2021 工商学院. All Rights Reserved. |
            <span
              style="text-decoration: underline; cursor: pointer"
              @click="goLink"
              >鄂公网安备42010502000137号</span
            >
          </div>
          <div class="ft-12-ca">
            违法和不良信息举报电话:027-84841873 举报邮箱:430065
            网上有害信息举报专区
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { path2 } from "@/utils/path.js";
export default {
  data() {
    return {
      readCount: this.$store.state.readCount,
      total: 0,
      user: this.$store.state.userInfo,
      searchTxt: "",
      lastSort: {},
      childSort: "",
      courseSort: "",
      specialtys: [],
      value: "",
      token: "",
      courseCateList: [],
      props: {
        value: "id",
        label: "specialtyName",
      },
    };
  },

  beforeRouteUpdate(to, from, next) {
    // just use `this`
    // console.log(to.name, from.name);
    if (from.name === "classify" && to.name !== "classify") {
      this.lastSort = {};
      this.childSort = "";
      this.courseSort = "";
    }
    next();
  },

  // computed: {
  //   dom() {
  //     return this.$refs.navTabs;
  //   },
  // },

  // watch: {
  //   dom(value) {
  //     console.log(value);
  //     this.$nextTick(() => {
  //       this.$refs.navTabs.$refs.nav.$nextTick(() => {
  //         // 此时tab的nav才渲染dom 否则拿不到el-tabs__item
  //         var target = document.getElementsByClassName("el-tabs__item");
  //         let that = this;
  //         for (let i = 0; i < target.length; i++) {
  //           target[i].addEventListener("mouseover", () => {
  //             that.$refs.navTabs.handleTabClick(1, String(i));
  //           });
  //         }
  //       });
  //     });
  //   },
  // },

  watch: {
    "$store.state.userInfo": {
      handler(value) {
        // console.log(value, "value");
        this.user = value;
        if (JSON.stringify(this.user) == "{}" || !this.user) {
          localStorage.removeItem("token");
          window.location.reload();
        }
      },
      deep: true,
    },
    "$store.state.readCount"() {
      this.getNews();
    },
  },

  created() {
    var token = this.$store.state.token || localStorage.getItem("token");
    this.token = token;
    this.getCourseCateList();
    this.getSpecialty();
  },

  mounted() {
    this.$refs.navTabs.$refs.nav.$nextTick(() => {
      // 此时tab的nav才渲染dom 否则拿不到el-tabs__item
      var target = document.getElementsByClassName("el-tabs__item");
      let that = this;
      for (let i = 0; i < target.length; i++) {
        target[i].addEventListener("mouseover", () => {
          that.$refs.navTabs.handleTabClick(1, String(i));
        });
      }
    });
    if (localStorage.getItem("token")) {
      this.getNews();
    }
  },

  methods: {
    hoverTab(e) {
      if (e.target.className === "tab-lable") {
        const name = e.target.outerText.trim();
        const index = this.specialtys.find((s) => s.specialtyName === name);
        this.courseSort = index.id;
        // console.log(index);
      }
    },
    async getNews() {
      const msg = await this.$http.get("server/portal/message/messageList");
      const sysMsg = await this.$http.get(
        "server/portal/message/informMessageList"
      );
      // const list = [...msg.rows, ...sysMsg.rows].filter((s) => s.hasRead === 0);

      this.total = msg.data.messageCount + sysMsg.data.messageCount;
    },
    handleCommand(command) {
      if (!command) {
        return;
      }
      this[command]();
    },

    userInfo() {
      if (!this.token) {
        window.location.reload();
        return;
      }
      this.$router.push({
        name: "user",
        query: { defaultActive: "8", t: new Date().getTime() },
      });
    },

    adminA() {
      const token = localStorage.getItem("token");
      localStorage.setItem("Access-Token", token);
      window.open(path2);
    },

    userSet() {
      if (!this.token) {
        window.location.reload();
        return;
      }
      this.$router.push({
        name: "user",
        query: { defaultActive: "9", t: new Date().getTime() },
      });
    },

    async logout() {
      // await this.$store.dispatch("setToken", "");
      // this.$nextTick(() => {
      //   this.$router.push("/login");
      // });

      this.$confirm("确认退出登录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$store.dispatch("setToken", "");
          this.$nextTick(() => {
            this.$router.push("/login");
          });
          this.$message({
            type: "success",
            message: "退出成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    tabClick(e) {
      const specialty = this.specialtys.find((s) => s.id === e.name);
      this.childSort = "";
      if (!specialty.cmsSpecialtyList.length) {
        this.lastSort = specialty;
      }

      if (this.$route.query.active !== e.name) {
        this.$router.push({
          name: "classify",
          query: {
            active: e.name,
            t: new Date().getTime(),
          },
        });
      }
    },
    getLastSort(lastSort, id) {
      // console.log(lastSort, "lastSort");
      this.childSort = lastSort.id;
      this.lastSort = lastSort;
      if (this.$route.query.son !== lastSort.id) {
        this.$router.push({
          name: "classify",
          query: {
            ...this.$route.query,
            son: lastSort.id,
            active: id,
            t: new Date().getTime(),
          },
        });
      }
    },
    getSpecialty() {
      this.$http.get("server/portal/home/specialty").then((res) => {
        if (res.status == 200) {
          this.specialtys = res.data;
          this.specialtys = this.specialtys.filter(
            (v) => v.cmsSpecialtyList.length !== 0
          );
          // console.log(this.specialtys, "this.specialty");
        }
      });
    },

    goSearch() {
      this.$router.push({
        name: "search",
        query: {
          t: new Date().getTime(),
          type: "course",
          txt: this.searchTxt,
          courseSort: this.courseSort,
          childSort: this.childSort,
        },
      });
    },

    goHome() {
      this.$router.push({ name: "home" });
    },

    // 导航菜单选择回调
    menuSelect(e) {
      // console.log(e);
      // if (this.$route.name === "classify") {
      //   console.log("刷新页面");
      // } else {
      //   this.$router.push({ name: "classify" });
      // }
      this.$router.push({ name: "classify" });
    },

    goMsg() {
      // if (!this.token) {
      //   this.$message.info("请登录查看");
      //   return;
      // }
      // if (this.$route.name === "message") {
      //   console.log("刷新页面");
      // } else {
      //   this.$router.push({ name: "message" });
      // }
      this.$router.push({ name: "message" });
    },

    goUserInfo(defaultActive) {
      // if (!this.token) {
      //   // window.location.reload();
      //   this.$message.info("请登录查看");
      //   return;
      // }
      this.$router.push({
        name: "user",
        query: { defaultActive, t: new Date().getTime() },
      });
    },

    goStudy() {
      if (this.$route.name === "user") {
        window.location.reload();
      } else {
        this.$router.push({ name: "user", query: { defaultActive: "2" } });
      }
    },
    toLogin() {
      this.$router.push({
        path: "/login",
        query: {
          type: "login",
        },
      });
    },
    toRegister() {
      this.$router.push({
        path: "/login",
        query: {
          type: "register",
          from: "new",
        },
      });
    },

    //获取课程分类
    getCourseCateList() {
      this.$http.get("server/portal/home/specialty").then((res) => {
        if (res.status == 200) {
          this.courseCateList = res.data;
          // console.log(res, "课程分类");
          this.$store.commit("setCourseType", this.courseCateList);
        }
      });
    },

    // 跳转外部链接
    goLink() {
      open("https://beian.miit.gov.cn/#/Integrated/index");
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin width() {
  min-width: 960px;
}

.se-container {
  &-content {
    min-height: calc(100vh - 40px - 60px - 150px);
  }
}

.se-header-content,
.se-container-content,
.se-footer-content {
  @include width;
}

/deep/.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: rgba(228, 67, 82, 0.1);
  color: #e44352 !important;
  .img-1 {
    content: url("../assets/icons/admin2.png");
  }
  .img-2 {
    content: url("../assets/icons/avaUser2.png");
  }
  .img-3 {
    content: url("../assets/icons/avaSet2.png");
  }
  .img-4 {
    content: url("../assets/icons/avaLogout2.png");
  }
}

input {
  color: #122e29;
  border: 1px solid #ccc;
  background-color: #fff;
  border-radius: 5px 0 0 5px;
  height: 40px;
  padding-left: 10px;
}
input:focus {
  border: 1px solid rgba(228, 67, 82, 0.5);
}

.el-button {
  border-radius: 0 5px 5px 0;
}

.se-line {
  width: 1px;
  height: 15px;
  border-left: 1px solid #333;
}

.se-footer-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bgc-333 {
  background-color: #2f3030;
}

/deep/ .el-submenu__title {
  padding: 0;
}

/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
  border: none;
}

/deep/ .el-menu.el-menu--horizontal {
  border: none;
}

/deep/ .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border: none;
}

.title-tab {
  display: flex;
  /deep/ .el-tabs__header {
    margin-right: 0 !important;
    width: 130px;
    .is-active {
      background-color: rgba(228, 67, 82, 0.1);
      color: #e44352;
    }
    .el-tabs__active-bar {
      display: none;
    }
    .el-tabs__item {
      padding: 0 36px;
      text-align: left;
      &:hover {
        color: #e44352;
      }
    }
  }
  /deep/ .el-tabs__content {
    flex: 1;
    .el-tab-pane {
      width: 100%;
      ul {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        li {
          width: 100%;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #7d7d7d;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          &:hover {
            color: #e44352;
          }
        }
        .active {
          text-decoration: underline;
          color: #e44352;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.el-menu--horizontal .el-menu .el-menu-item:hover {
  background-color: rgba(228, 67, 82, 0.1);
  color: #e44352 !important;
}
.el-menu--horizontal .el-menu .el-submenu__title:hover {
  background-color: rgba(228, 67, 82, 0.1);
  color: #e44352 !important;
}
</style>
<style>
.el-menu--popup {
  margin-top: 12px !important;
  padding: 20px 0 !important;
  border-radius: 10px !important;
  position: relative;
}

.el-menu--popup::after {
  position: absolute;
  top: -12px;
  left: 30px;
  content: "";
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 12px solid #ffffff;
}
</style>
